var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VWrapper',{attrs:{"title":"paypal.success","disable-breadcrumbs":""}},[_vm._v(" "+_vm._s(_vm.$t('paypal.description'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }